<div class="bg-m0 flex select-none flex-col p-9">
  <div
    data-cy="editChartInfoDialogTitle"
    class="text-s2 mb-9 mt-5 flex-grow text-left text-2xl font-semibold"
    >Edit Chart</div
  >

  <div class="text-s400 text-base">{{ chartPath }}</div>

  <div class="mt-9 flex flex-row items-start">
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
        >Title</div
      >
    </div>

    <div [formGroup]="titleForm" class="ml-5 flex flex-col items-start">
      <input
        autocomplete="off"
        spellcheck="false"
        data-cy="editChartInfoDialogTitleInput"
        class="form-input border-s3 focus:border-m600 h-9 w-96 rounded"
        [ngClass]="{
          'border-r600':
            titleForm.controls['title'].invalid &&
            titleForm.controls['title'].touched
        }"
        formControlName="title"
      />
      <m-validation [control]="titleForm.controls['title']"></m-validation>
    </div>
  </div>

  <div class="mt-2 flex flex-row items-start">
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
        >Space</div
      >
    </div>

    <div
      class="ml-5 flex flex-col items-start"
      tp="Admin or Editor role required"
      [tpIsEnabled]="canChangeSpace === false"
    >
      <ng-select
        #editChartInfoDialogSpaceSelect
        [fixNgSelectBottom]="editChartInfoDialogSpaceSelect"
        data-cy="editChartInfoDialogSpaceSelect"
        class="select-h-10 w-96 flex-shrink-0"
        [ngClass]="{
          'pointer-events-none': canChangeSpace === false
        }"
        [items]="spacesPlusEmpty"
        [multiple]="false"
        [searchable]="true"
        [clearable]="false"
        [disabled]="canChangeSpace === false"
        [(ngModel)]="selectedSpace"
        (change)="spaceChange()"
        (keyup.esc)="
          $event.stopImmediatePropagation();
          editChartInfoDialogSpaceSelect.blur()
        "
        (keyup.enter)="
          $event.stopImmediatePropagation();
          editChartInfoDialogSpaceSelect.blur()
        "
        appendTo="body"
        bindLabel="label"
        bindValue="space"
      >
        <ng-template ng-label-tmp let-item="item">
          <div class="ml-1 truncate text-base">{{
            item.space === emptySpaceName ? '' : item.label
          }}</div>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <div class="ml-1 truncate text-base">{{ item.label }}</div>
        </ng-template>
      </ng-select>
    </div>
  </div>

  <div class="mt-8 flex min-h-[100px] flex-row items-start">
    <div class="flex flex-col">
      <div class="text-s1 flex h-9 w-32 select-none items-center text-base"
        >Access Roles</div
      >
    </div>

    <div class="ml-5 flex flex-col items-start">
      <div [tp]="templateAccessRoles" [tpIsEnabled]="roles.length === 0">
        <ng-template #templateAccessRoles>
          <div>Project has no roles</div>
        </ng-template>

        <ng-select
          #editChartInfoDialogRoleSelect
          [fixNgSelectBottom]="editChartInfoDialogRoleSelect"
          data-cy="editChartInfoDialogRoleSelect"
          class="select-h-10 w-96 flex-shrink-0"
          [items]="roles"
          [multiple]="true"
          [searchable]="true"
          [clearable]="true"
          [(ngModel)]="selectedAccessRoles"
          (change)="accessRolesChange()"
          (keyup.esc)="
            $event.stopImmediatePropagation();
            editChartInfoDialogRoleSelect.blur()
          "
          (keyup.enter)="
            $event.stopImmediatePropagation();
            editChartInfoDialogRoleSelect.blur()
          "
          appendTo="body"
          bindLabel="roleId"
          bindValue="roleId"
        >
          <ng-template ng-label-tmp let-item="item">
            <div
              class="truncate rounded bg-green-200 px-2 text-base text-green-700"
              >{{ item.roleId }}</div
            >
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            <div class="ml-1 truncate text-base">{{ item.roleId }}</div>
          </ng-template>
        </ng-select>

        <div class="ml-[14px] mt-2 flex w-96 flex-wrap gap-2 text-base">
          <span
            *ngFor="let accessRole of combinedAccessRoles"
            class="truncate rounded px-2"
            [ngClass]="{
              'bg-green-200 text-green-700': accessRole.isDirect,
              'bg-slate-200 text-slate-700': !accessRole.isDirect
            }"
          >
            {{ accessRole.role }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-9">
    <button
      data-cy="editChartInfoDialogCreateButton"
      class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
      type="button"
      (click)="save()"
      >Save</button
    >

    <button
      data-cy="editChartInfoDialogCancelButton"
      class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
      type="button"
      (click)="cancel()"
      >Cancel</button
    >
  </div>
</div>
